import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import fontAwesome from './plugins/font-awesome'
import ui from './plugins/ui'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import JsonExcel from "vue-json-excel";

Vue.use(BootstrapVue)
Vue.use(fontAwesome)
Vue.use(Vuelidate)
Vue.use(ui)
Vue.component("downloadExcel", JsonExcel);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
